import React, { useEffect } from 'react';

import {
  Button,
  Row,
  Col,
  Form,
  Tab,
} from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

import { editConfiguration } from 'apis/admin/configApi';

function BasicSetting({ tabEventKey, configData, getAllConfiguration }) {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  });

  // react-hook-form에 기본 값 설정하기
  useEffect(() => {
    if (configData) {
      for (const key in configData) {
        setValue(key, configData[key]);
      }
    }
  }, [configData]);


  // 환경 설정 - 기본 정보 저장
  const onSubmit = async (data) => {
    let dataToSubmit = data;
    for (const key in dataToSubmit) {
      if (isNaN(dataToSubmit[key]) && dataToSubmit[key] !== '') {
        dataToSubmit[key] = dataToSubmit[key].trim();
      }
    }
    
    await editConfiguration(dataToSubmit)
      .then(async (response) => {
        if (response.data.success) {
          Swal.fire({
            icon: 'success',
            title: '환경 설정 저장을 완료했습니다.',
          }).then(async () => {
            await getAllConfiguration();
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            title: '환경 설정을 저장할 수 없습니다.',
            text: '잠시 후 다시 시도해주세요.',
          }).then(() => {
            return;
          });
        }
      })
      .catch(error => {
        console.error('error occured in BasicConfig/BasicSetting.js - onSubmit() ', error);

        Swal.fire({
          icon: 'error',
          title: '환경 설정을 저장할 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });
  };

  return (
    <Tab.Pane eventKey={tabEventKey}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            웹사이트 제목
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_title')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            수신 이메일
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('receive_email')}
            />
            <Form.Text muted>
              사용자가 이용 문의와 시설 예약 시 발송되는 정보를 받을 이메일 주소를 입력하세요.
            </Form.Text>
          </Col>
        </Form.Group>
        {/* <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            웹사이트 로고
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('site_logo')}
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            관리자 페이지 로고
          </Form.Label>
          <Col>
            <Form.Control
              type="text"
              {...register('admin_logo')}
            />
          </Col>
        </Form.Group> */}
        {/* <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            하단 스크립트
          </Form.Label>
          <Col>
            <Form.Control
              as="textarea"
              rows={5}
              {...register('footer_script')}
            />
            <Form.Text muted>
              페이지 하단에 스크립트를 삽입합니다. 통계 스크립트 등을 입력할 수 있습니다. 관리자 페이지에는 반영되지 않습니다.
            </Form.Text>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            단어 필터링
          </Form.Label>
          <Col>
            <Form.Control
              as="textarea"
              rows={5}
              {...register('spam_word')}
            />
            <Form.Text muted>
              필터링하고 싶은 단어를 쉼표(,)로 구분하여 입력해주세요. 해당 단어는 원글 작성, 댓글 작성의 경우에 입력이 제한되어 있습니다.
            </Form.Text>
          </Col>
        </Form.Group> */}
        {/* <Form.Group as={Row} className="align-items-center">
          <Form.Label column sm={2} className="text-sm">
            최고 레벨
          </Form.Label>
          <Col sm={2}>
            <Form.Control
              type="number"
              {...register('max_level', {
                valueAsNumber: '0 이상의 숫자만 입력 가능합니다.',
                min: {
                  value: 0,
                  message: '0 이상의 숫자만 입력 가능합니다.',
                },
                max: {
                  value: 1000,
                  message: '1000 이하의 숫자만 입력 가능합니다.',
                },
              })}
              isInvalid={errors.max_level}
            />
            <Form.Control.Feedback type="invalid">
              {errors.max_level && errors.max_level.message}
            </Form.Control.Feedback>
          </Col>
        </Form.Group> */}
        <Row className="justify-content-center pt-5">
          <Button type="submit" variant="primary">
            저장하기
          </Button>
        </Row>
      </Form>
    </Tab.Pane>
  );
}

export default BasicSetting;
